import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';
import { GENERATED_PROMO_TEXT, GENERATED_PROMO_TEXT_REGEX } from './consts';
import { PromoCodeType } from './types';

export const generatePromoCodeText = (promoCode?: PromoCodeType, excludeReplaceUsePromo?: boolean) => {
  if (!promoCode) {
    return '';
  }
  const { code, isPercentage, minOrderValue, value } = promoCode;

  const valueOff = isPercentage ? `${value}%` : `$${value}`;
  const valueOffText = GENERATED_PROMO_TEXT.VALUE_OFF.replace(Delimiter, valueOff);
  const usePromoText = excludeReplaceUsePromo
    ? GENERATED_PROMO_TEXT.USE_PROMO
    : GENERATED_PROMO_TEXT.USE_PROMO.replace(Delimiter, code);
  const minOrderText = GENERATED_PROMO_TEXT.MIN_ORDER.replace(Delimiter, `$${minOrderValue}`);

  return `${valueOffText} ${usePromoText}${minOrderValue ? ` ${minOrderText}` : ''}`;
};

export const splitPromoCodeText = (input?: string | null) => {
  const comment = input ?? '';
  const promoCodeTextRegex = new RegExp(GENERATED_PROMO_TEXT_REGEX);
  const promoCodeResult = comment.match(promoCodeTextRegex);
  if (promoCodeResult) {
    const [match, value, promoCode] = promoCodeResult;
    const promoCodeCommentIndex = comment.lastIndexOf(match);
    return {
      comment: comment.substring(0, promoCodeCommentIndex),
      promoText: comment.substring(promoCodeCommentIndex),
      promoCode,
      value,
    };
  }
  return { comment, promoText: '', promoCode: '', value: '' };
};
